import type { AxiosRequestConfig } from "axios";
import type { IAddress, IAddressComponent, IAddresses } from "@/types/address";
import type { IRepositoryOptions } from "@/types/common";
import { BaseRepository } from "../BaseRepository";
import type { AddressService } from "./service";
import type { IGetAddressDetailsInput, IGetAddressesRequest } from "./types";

const getComponent = (components: IAddressComponent[], type: string) => {
  return components.find((c) => c.types.includes(type))?.long_name || "";
};

export class AddressRepository extends BaseRepository {
  constructor(
    private readonly service: AddressService,
    options?: IRepositoryOptions,
  ) {
    super(options);
  }

  async getAddresses(
    p: IGetAddressesRequest,
    c?: AxiosRequestConfig,
  ): Promise<IAddresses> {
    const response = await this.handleRequest(this.service.getAddresses, p, c);
    return response.data;
  }

  async getAddressDetails(
    p: IGetAddressDetailsInput,
    c?: AxiosRequestConfig,
  ): Promise<IAddress> {
    const response = await this.handleRequest(
      this.service.getAddressDetails,
      { placeId: p.placeId },
      c,
    );
    const place = response.data.result;
    const components = place.address_components;

    return {
      name: p.name,
      googlePlaceId: place.place_id,
      addressLine1: place.name,
      addressLine2: "",
      city: getComponent(components, "locality"),
      state: getComponent(components, "administrative_area_level_1"),
      country: getComponent(components, "country"),
      zipCode: getComponent(components, "postal_code"),
      latitude: place.geometry.location.lat,
      longitude: place.geometry.location.lng,
    };
  }
}
